import React from "react";
/**
 * Utility function to highlight search terms in text
 * @param text - The text to search in
 * @param searchTerm - The term to highlight
 * @param highlightStyle - Optional custom styles for highlighting
 * @returns JSX element with highlighted text
 */
export const highlightText = (text, searchTerm, highlightStyle = {
    fontWeight: "bold",
}) => {
    if (!searchTerm || !text || searchTerm.trim() === "") {
        return React.createElement(React.Fragment, null, text);
    }
    // Escape special regex characters in search term
    const escapedSearchTerm = searchTerm.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    // Create case-insensitive regex
    const regex = new RegExp(`(${escapedSearchTerm})`, "gi");
    // Split text by search term while preserving the search term
    const parts = text.split(regex);
    return (React.createElement(React.Fragment, null, parts.map((part, index) => {
        // Check if this part matches the search term (case-insensitive)
        const isMatch = part.toLowerCase() === searchTerm.toLowerCase();
        if (isMatch) {
            return (React.createElement("span", { key: index, style: highlightStyle }, part));
        }
        return part;
    })));
};
/**
 * Hook to get highlighted text with search term
 * @param text - The text to highlight
 * @param searchTerm - The search term to highlight
 * @param highlightStyle - Optional custom styles for highlighting
 * @returns JSX element with highlighted text
 */
export const useHighlightText = (text, searchTerm, highlightStyle) => {
    return React.useMemo(() => highlightText(text, searchTerm, highlightStyle), [text, searchTerm, highlightStyle]);
};
